import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Container, FormGroup, Input, Row, Col, Label, Button, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import { getBodyTypes, } from "../../../services/bodyService";
import { getIdentity } from "../../../services/identityService";
import { getAcademeicDegree } from "../../../services/acedmeicdegreeService";
import { getColleges } from "../../../services/collegeService";
import { getLanguages } from "../../../services/languageService";
import { getSubTopicsByTopic, getTopicFilter } from "../../../services/topicService"; 
import { getSubExpertiseByExpertise , getExpertiseFilter} from "../../../services/expertizeService";
import { getInterestsOptions } from "../../../services/InterestService";
import { formatBytes, notifyError, notifySuccess } from "../../../utils/utils";
import { getUser, addUser, updateUser, getUserExpertise } from "../../../services/userService";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-input-range/lib/css/index.css";
import InputRange from 'react-input-range';
import moment from  'moment';
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

const style = {
    imagetitle : {"fontSize":"16px", "lineHeight": "24px", "fontWeight":"500"},
    imageWrap: {"overflowX":"auto", "display" :"flex" ,"overFlowY": "auto"},
    imageUpload: {"border": "1px solid #ccc", "display": "inline-flex", "justifyContent":"center", "borderRadius":"8px", "width": "120px", "height": "120px", "cursor":"pointer", "position":"relative"},
    uploadInput: {"position": "absolute", "visibility": "hidden", "height": "0", "width": "0"},
    uploadedImage: {"marginLeft": "12px", "position": "relative", "display": "inline-flex"},
    uploadedImageImg: {"width":"120px", "height":"120ox", "maxHeight": "120px", "borderRadius" :"8px", "objectFit":"contain", "border": "1px solid #e6e6e6"},
    imageDeleteButton : { position: "absolute", right: "8px", color: "#ca2121", top: "8px", "cursor": "pointer" }
}


class AddUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            isEditing: false,
            colleges: [],
            languages: [],
            document: "",
            galleryImages: [],
            redirect: false,
            bodyTypeOptions: [],
            identityOptions: [],
            degreeOptions: [],
            collegeOptions: [],
            languageOptions: [],
            topicOptions:[],
            subTopicOptions:[],
            expertiseOptions:[],
            subExpertiseOptions:[],
            interestsOptions:[],
            // twitter_visible: 
            expertise: {
                expertise: [],
                topic: [],
                interest: [],
                wish_lits: [
                    {
                        "name": "",
                        "last_name": "",
                        "social" : [
                            {"icon":0,"isSelect":true,"link": "","social_name":"Instagram"},
                            {"icon":0,"isSelect":true,"link": "","social_name":"Twitter"}
                        ]
                    }
                ]
            },
            ageRange: {min: 18, max: 25},
            alert_confirm: false,
            delete_key: '',
            delete_index: -1,
            delete_expetise: false
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages: {}, autoForceUpdate: this,
            validators: {
                expertise: {
                    message: 'Please Select Expertise',
                    rule: (val, params, validator) => {
                        console.log(val);
                        // alert(val)
                        return val && val != ""  ? true : false
                    },
                },
                subexpertise: {
                    message: 'Please Select Sub Expertise',
                    rule: (val, params, validator) => {
                        return val != "" ? true : false
                    },
                },
                topic: {
                    message: 'Please Select Topic',
                    rule: (val, params, validator) => {
                        return val != "" ? true : false
                    },
                },
                subtopic: {
                    message: 'Please Select Sub Topic',
                    rule: (val, params, validator) => {
                        return val != "" ? true : false
                    },
                },
                interest: {
                    message: 'Please Select Interest',
                    rule: (val, params, validator) => {
                        return val != "" ? true : false
                    },
                },
            }
        });

        this.handleChange = this.handleChange.bind(this);
        this.loadUser = this.loadUser.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loadSubTopic =  this.loadSubTopic.bind(this);

      
    }

   


    loadUser(id) {
        getUser(id)
            .then(res => {
                const { data } = res;
                if (data.status) {
                    const { colleges, languages, galleryImages, ..._user } = data.user;
                    _user.DOB = new Date(_user.DOB);
                    _user.body_type =  _user.body_type !== null ? _user.body_type.body_type_id : "";
                    _user.further_identity = _user.further_identity ? _user.further_identity.identity_id : "";
                    _user.academic_degree =  _user.academic_degree ? _user.academic_degree.academic_degree_id : "";
                    
                    this.setState({
                        user: _user,
                        colleges: colleges,
                        languages: languages,
                        galleryImagesSrc: galleryImages,
                        isEditing: true,
                    });
                } else {
                    notifyError(data.message);
                }
            });


            getUserExpertise(id)
            .then(res => {
                const { data } = res;
                // console.log(data);
                if(data.status) {
                    let wishes = [...this.state.expertise.wish_lits];
                    if(data.expertisesReponse.wishlist)
                        if(data.expertisesReponse.wishlist.length > 0) {

                            if(data.expertisesReponse.wishlist[0] && data.expertisesReponse.wishlist[0].name) {
                                this.setState({
                                    wishlist_name: data.expertisesReponse.wishlist[0].name
                                });
                            }

                            if(data.expertisesReponse.wishlist[0] && data.expertisesReponse.wishlist[0].last_name) {
                                this.setState({
                                    wishlist_last_name: data.expertisesReponse.wishlist[0].last_name
                                });
                            }

                            if(data.expertisesReponse.wishlist[0].social && data.expertisesReponse.wishlist[0].social.length > 0){
                                if(data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Instagram")) {
                                    this.setState({ 
                                        instagram_link: data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Instagram").link || "",
                                        // instagram_visible: data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Instagram").isSelect
                                    })
                                }
                                if(data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Twitter")) {
                                    this.setState({ 
                                        twitter_link: data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Twitter").link || "",
                                        // twitter_visible: data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Twitter").isSelect
                                    })
                                }
                            }
                        }
                    this.setState({
                        expertise: { 
                            expertise:data.expertisesReponse.expertise || [],
                            topic:data.expertisesReponse.topic || [],
                            interest:data.expertisesReponse.interest || [],
                            wish_lits: wishes,
                            ...data.expertisesReponse
                        },
                        ageRange: {
                            min: data.expertisesReponse.age_range && data.expertisesReponse.age_range.split(";")[0] || 18,
                            max: data.expertisesReponse.age_range && data.expertisesReponse.age_range.split(";")[1] || 25
                        }
                    });

                } else {
                    this.setState({
                        alertModel: true,
                        alertMessage: data.message,
                        alertType: "danger"
                    });
                }
            });
    
    }


    handleChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSubmit(e) {
        e.preventDefault();

        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }


        let formData = new FormData();

        Object.keys(this.state.user).forEach(key => formData.append(key, this.state.user[key]));

        formData.append("languages", JSON.stringify(this.state.languages));
        formData.append("colleges", JSON.stringify(this.state.colleges));
        
        
        if(this.state.isEditing){
            formData.append("galleryImagesSrc" , JSON.stringify(this.state.galleryImagesSrc.map(x => x.split(`user${this.state.user.user_id}/`)[1])));
            if(this.state.user.document) {
                // console.log( this.state.user.document.split("Avatars/"));
                formData.append("documentSrc", this.state.user.document.split(`user${this.state.user.user_id}/`)[1]);
            }
            if(this.state.user.avatar) {
                formData.append("avatarSrc" ,this.state.user.avatar.split(`Avatars/`)[1]);
            }
        }

        if (this.state.document)
            formData.append("document", this.state.document);

        if (this.state.galleryImages.length > 0) {
            for (const file of this.state.galleryImages) {
                formData.append("galleryImage", file);
            }
        }

        if(this.state.avatar) {
            formData.append("avatar", this.state.avatar);
        }


        // console.log(this.state.expertise);

        let expertise = {};

        

        expertise["expertise_id"] = this.state.expertise.expertise_id;
        expertise['expertise'] = this.state.expertise.expertise || [];
        expertise['other_expertise'] = this.state.expertise.other_expertise;
        expertise['topic'] = this.state.expertise.topic || [];
        expertise['other_topic'] = this.state.expertise.other_topic;
        expertise['converse_with'] = this.state.expertise.converse_with;
        expertise['age_range'] = [this.state.ageRange.min,this.state.ageRange.max];
        expertise['maximum_distance'] = this.state.expertise.maximum_distance;
        expertise['body_type'] = this.state.expertise.body_type;
        expertise['interest'] = this.state.expertise.interest || [];
        // }
        
        expertise['wishlist'] =  [
            {
                "name": this.state.wishlist_name,
                "last_name": this.state.wishlist_last_name,
                "social" : [
                    {"icon":0,"isSelect":false,"link": this.state.instagram_link,"social_name":"Instagram"},
                    {"icon":0,"isSelect":false,"link": this.state.twitter_link,"social_name":"Twitter"}
                ]
            }
        ];
        // console.log( expertise['wishlist']);
        
        // console.log(JSON.stringify(expertise));

        // console.log(expertise['expertise']);

        formData.append("expertise", JSON.stringify(expertise));

        if (this.state.isEditing) {
            updateUser(this.state.user.user_id, formData)
                .then(res => {
                    console.log(res.data);
                    const { data } = res;
                    if (data.status) {
                        notifySuccess(data.message);
                        this.loadUser(this.state.user.user_id);
                    } else {
                        notifyError(data.message);
                    }
                });
        } else {
            addUser(formData)
                .then(res => {
                    console.log(res.data);
                    const { data } = res;
                    if (data.status) {
                        notifySuccess(data.message);
                    } else {
                        notifyError(data.message);
                    }
                });
        }


        // console.log("help");
    }

    updateExpertise(data) {
        console.log(data);
        this.setState({
            expertise: {
                ...this.state.expertise,
                [data.key] : data.value
            }
        });
    }

    loadOption = async () => {
        await getBodyTypes().then(res => this.setState({ bodyTypeOptions: res.data.data }));
        await getIdentity().then(res => this.setState({ identityOptions: res.data.data }));
        await getAcademeicDegree().then(res => this.setState({ degreeOptions: res.data.data }));
        await getColleges().then(res => this.setState({ collegeOptions: res.data.data }));
        await getLanguages().then(res => this.setState({ languageOptions: res.data.data }));
        await getTopicFilter().then(res => this.setState({topicOptions: res.data.topics}));
        await getSubTopicsByTopic().then(res =>this.setState({ subTopicOptions: res.data.subtopics }));
        await getExpertiseFilter().then(res => this.setState({expertiseOptions: res.data.expertises}));
        await getSubExpertiseByExpertise().then(res =>this.setState({ subExpertiseOptions: res.data.subexpetises }));
        await getInterestsOptions().then(res =>this.setState({ interestsOptions: res.data.interests }));
    }

    componentDidMount() {
     
        this.loadOption();

        if (this.props.match.params.id) {
            this.loadUser(this.props.match.params.id);
        }
    }

    deleteItem() {
        const key = this.state.delete_key;
        const index = this.state.delete_index;
        console.log(key);
        console.log(index);
        if(key == "document") {
            this.setState({
                user: {
                    ...this.state.user,
                    document: null
                }
            })
        }
        else if(!this.state.delete_expetise) {
            this.setState({
                [key]: [...this.state[key]].filter((y, j) =>  index !== j),
                // galleryImages: [...this.state.galleryImages].filter((y, j) => index !== j)
            })
        } else {
            this.updateExpertise({
                key: key,
                value: [...this.state.expertise[key]].filter((y,j) => index !== j)
            });
        }

        this.setState({
            alert_confirm: false,
            delete_key: "",
            delete_index: -1,
            delete_expetise: false    
        });
    }

    renderFile(file, index, flag) {
        return(
            <section style={style.uploadedImage}>
            <img
                 src={flag ? URL.createObjectURL(file) : file}
                style={style.uploadedImageImg}
                alt={"No Available"}
            />
            <span
                key={index + "l"}
                style={style.imageDeleteButton}
                onClick={() => {
                    if (flag) {
                        this.setState({
                            delete_key: "galleryImages",
                            delete_index: index,
                            alert_confirm: true
                            // galleryImages: [...this.state.galleryImages].filter((y, j) => index !== j)
                        })
                    } else {
                        this.setState({
                            delete_key: "galleryImagesSrc",
                            delete_index: index,
                            alert_confirm: true
                            // galleryImagesSrc: [...this.state.galleryImagesSrc].filter((y, j) => index !== j)
                        })
                    }
                }}
            >
                {" "}
                <i className="fas fa-times-circle"></i>
            </span>
        </section>

        //     <Card
        //         className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
        //         key={index}
        //     >

        //     <div className="p-2">
        //         <Row className="align-items-center">
        //             <Col lg={10} md={10} sm={10} xs={10}>
        //                 <Link
        //                     to="#"
        //                     className={`text-${flag ? "muted" : "info"} font-weight-bold`}
        //                 >
        //                     {!flag ? file.split("Avatars/")[1] : file.name}
        //                 </Link>
        //                 { flag && <strong>{formatBytes(file.size)}</strong> }
        //             </Col>
        //             <Col lg={2} md={2} sm={2} xs={2}>
        //                 <p className="mb-0">
        //                     <span className="pull-right" onClick={() => {
        //                         if(flag) {
        //                             this.setState({
        //                                 galleryImages: [...this.state.galleryImages].filter((y, j) => index !== j)
        //                             })
        //                         } else {
        //                             this.setState({
        //                                 galleryImagesSrc: [...this.state.galleryImagesSrc].filter((y, j) => index !== j)
        //                             })    
        //                         }
        //                     }}>
        //                         <i className="ml-2 text-danger pull-right fas fa-times"></i>
        //                     </span>
        //                 </p>
        //             </Col>
        //         </Row>
        //     </div>
        // </Card>
        )
    }

    checkFile(file) {
        const type = file.type.split("/");
        if(["jpg","png", "jpeg"].includes(type[1])) {
            console.log("treu");
            return true
        } else {
            return false
        }
    }

    loadSubTopic(topic) {
        getSubTopicsByTopic(topic)
        .then(res => {
            this.setState({
                subTopicOptions: res.data.subtopics
            })
        })
    }

    loadSubExpertyise(expertise) {
        getSubExpertiseByExpertise(expertise)
        .then(res => {
            this.setState({
                subExpertiseOptions: res.data.subexpetises
            })
        })
    }

    renderStar() {
        return(
            <span> <i className="text-danger fas fa-star-of-life 1x"></i></span>
        )
    }

    render() {

        const { user, bodyTypeOptions, identityOptions, degreeOptions, expertise, wish_lits } = this.state;

        const interets = this.state.interestsOptions && this.state.interestsOptions.map(x => {
            return {
                name: 'interest',
                value: x.interested_on_id,
                label: x.name
            }
        });

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Card>
                            <CardBody>
                                <h3>  {this.state.isEditing ? "Edit" : "Add"} User</h3>
                            </CardBody>
                        </Card>
                        <div style={{ "maxHeight": "1100px", "overflowY": "auto" }} >
                            <Card>
                                <CardBody>

                                    <Row>
                                        <Col lg={12}>   <strong><h3> Basic Details</h3></strong></Col>
                                    </Row>
                                    <Row className="mt-1">

                                        <Col lg={3}>
                                            <Label>Profile Picture</Label>
                                            <Input
                                                type="file"
                                                multiple
                                                name="images"
                                                onChange={e => {
                                                    if (e.target.files) {
                                                            if(this.checkFile(e.target.files[0])) {
                                                                const file =  e.target.files[0];
                                                                this.setState({
                                                                    avatar: file
                                                                })
                                                            } else {
                                                                notifyError("Only .jpg, .png, .jpeg files allowed")
                                                            }
                                                    }
                                                    e.target.value = "";
                                                }}
                                            />
                                             <section style={style.imageWrap} className="mt-1">
                                                 {
                                                     this.state.avatar ?
                                                 
                                                        <section style={style.uploadedImage}>
                                                            <img
                                                                src={URL.createObjectURL(this.state.avatar)}
                                                                style={style.uploadedImageImg}
                                                                alt={"No Available"}
                                                            />
                                                            {/* <span
                                                                key={"l"}
                                                                style={style.imageDeleteButton}
                                                                onClick={() => {
                                                                    if (flag) {
                                                                        this.setState({
                                                                            galleryImages: [...this.state.galleryImages].filter((y, j) => index !== j)
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            galleryImagesSrc: [...this.state.galleryImagesSrc].filter((y, j) => index !== j)
                                                                        })
                                                                    }
                                                                }}
                                                            >
                                                                {" "}
                                                                <i className="fas fa-times-circle"></i>
                                                            </span> */}
                                                        </section>
                                                    : 
                                                        <section style={style.uploadedImage}>
                                                            {   
                                                                this.state.user.avatar &&
                                                                <img
                                                                    src={this.state.user.avatar}
                                                                    style={style.uploadedImageImg}
                                                                    alt={"No Available"}
                                                                />
                                                            }
                                                        </section>
                                                }
                                             </section>
                                        </Col>
                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>First Name: {this.renderStar()} </Label>
                                                <Input
                                                    type="text"
                                                    value={user.first_name}
                                                    name="first_name"
                                                    onChange={this.handleChange}
                                                    bsSize="lg"
                                                    placeholder="First Name"
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('First name', user.first_name, 'required|alpha_num_space|min:5|max:20')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Middle Name:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.middle_name}
                                                    name="middle_name"
                                                    onChange={this.handleChange}
                                                    placeholder="Middle Name"
                                                />

                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Last Name: {this.renderStar()}</Label>
                                                <Input
                                                    type="text"
                                                    value={user.last_name}
                                                    name="last_name"
                                                    onChange={this.handleChange}
                                                    placeholder="Last Name"
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Last name', user.last_name, 'required|alpha_num_space|min:5|max:20')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>DOB: {this.renderStar()}</Label>
                                                <DatePicker
                                                    className="form-control"
                                                    selected={user.DOB}
                                                    name="DOB"
                                                    bsSize="lg"
                                                    onChange={date => {
                                                        this.handleChange({ target: { name: "DOB", value: date } })
                                                    }}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('DOB', user.DOB, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>mobile: {this.renderStar()}</Label>
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend" style={{"width" : "20%"}}>
                                                    <Input
                                                        // readOnly
                                                        type="text"
                                                        value={user.country_code}
                                                        name="country_code"
                                                        bsSize="lg"
                                                        onChange={this.handleChange}
                                                        placeholder="+91"
                                                    />
                                                    </InputGroupAddon>
                                                    <Input
                                                        // readOnly
                                                        type="text"
                                                        value={user.mobile_no}
                                                        name="mobile_no"
                                                        bsSize="lg"
                                                        onChange={this.handleChange}
                                                        placeholder="Mobile"
                                                    />
                                                </InputGroup>
                                                {/* <Input
                                                    // readOnly
                                                    type="text"
                                                    value={user.mobile_no}
                                                    name="mobile_no"
                                                    bsSize="lg"
                                                    onChange={this.handleChange}
                                                    placeholder="Mobile"
                                                /> */}
                                                {/* <span className="text-danger">
                                                    {this.validator.message('mobile', user.mobile_no, 'required|min:12|max:12')}
                                                </span> */}
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Email: {this.renderStar()}</Label>
                                                <Input
                                                    type="text"
                                                    value={user.email}
                                                    name="email"
                                                    onChange={this.handleChange}
                                                    placeholder="Email"
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Email', user.email, 'required|email')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Gender: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={user.gender}
                                                    name="gender"
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    <option value={"Male"}>Male</option>
                                                    <option value={"Female"}>Female</option>
                                                    <option value="Other">Others</option>
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('Gender', user.gender, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <Row>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>City of Primary Residence: {this.renderStar()}</Label>
                                                <Input
                                                    type="text"
                                                    value={user.city_of_primary_residence}
                                                    name="city_of_primary_residence"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('City of primary residense', user.city_of_primary_residence, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>State of Primary Residence: {this.renderStar()}</Label>
                                                <Input
                                                    type="text"
                                                    value={user.state_of_primary_residence}
                                                    name="state_of_primary_residence"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('State of primary residense', user.state_of_primary_residence, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>City of Secondary Residence:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.city_of_secondary_residence}
                                                    name="city_of_secondary_residence"
                                                    onChange={this.handleChange}
                                                />
                                                {/* <span className="text-danger">
                                                    {this.validator.message('City of secondary residense', user.city_of_secondary_residence, 'required')}
                                                </span> */}
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>State of Secondary Residence:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.state_of_secondary_residence}
                                                    name="state_of_secondary_residence"
                                                    onChange={this.handleChange}
                                                />
                                                {/* <span className="text-danger">
                                                    {this.validator.message('State of secondary residense', user.state_of_secondary_residence, 'required')}
                                                </span> */}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Height: (cm) {this.renderStar()}</Label>
                                                <Input
                                                    type="number"
                                                    value={user.height}
                                                    name="height"
                                                    min={0}
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Height', user.height, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Body Type:{this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={user.body_type}
                                                    name="body_type"
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    {
                                                        bodyTypeOptions.map((x, i) => <option key={i} value={x.body_type_id}>{x.name} </option>)
                                                    }
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('body type', user.body_type, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Further Identity: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={user.further_identity}
                                                    name="further_identity"
                                                    onChange={this.handleChange}
                                                >
                                                    <option>Select</option>
                                                    {
                                                        identityOptions.map((x, i) => <option key={i} value={x.identity_id}>{x.name} </option>)
                                                    }
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('Identity', user.further_identity, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                      
                                       
                                    </Row>
                                    <Row>
                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <Label>Job Title: {this.renderStar()}</Label>
                                            <Input
                                                type="text"
                                                value={user.job_title}
                                                name="job_title"
                                                onChange={this.handleChange}
                                            />
                                            <span className="text-danger">
                                                {this.validator.message('job_title', user.job_title, 'required')}
                                            </span>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <Label>Coins: {this.renderStar()}</Label>
                                            <Input
                                                type="number"
                                                value={user.coins}
                                                name="coins"
                                                min={0}
                                                onChange={this.handleChange}
                                            />
                                            <span className="text-danger">
                                                {this.validator.message('coins', user.coins, 'required')}
                                            </span>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <Label>Refereal Code: {this.renderStar()}</Label>
                                            <Input
                                                type="text"
                                                value={user.referral_code}
                                                name="referral_code"
                                                onChange={this.handleChange}
                                            />
                                            <span className="text-danger">
                                                {this.validator.message('referral code', user.referral_code, 'required')}
                                            </span>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <Label>Rating Point: {this.renderStar()}</Label>
                                            <Input
                                                type="number"
                                                value={user.rating_point}
                                                name="rating_point"
                                                min={0}
                                                onChange={this.handleChange}
                                            />
                                            <span className="text-danger">
                                                {this.validator.message('Rating point', user.rating_point, 'required')}
                                            </span>
                                        </Col>
                                    </Row>

                                    <Row className="mt-1">
                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Featured in Hall of Super Sage: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={user.to_be_feature}
                                                    name="to_be_feature"
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('Featured in Hall of Super Sage', user.to_be_feature, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Like to Profile in Hall of Super Sage: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={user.is_like_to_super_sages}
                                                    name="is_like_to_super_sages"
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('>Like to Profile in Hall of Super Sage', user.is_like_to_super_sages, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row className="mt-1">
                                        <Col lg={4}>
                                            <Label>Colleges and University</Label>
                                            <Input
                                                type="select"
                                                name="further_identity"
                                                onChange={e => {
                                                    // if (!this.state.colleges.includes(e.target.value)) {
                                                        this.setState({
                                                            colleges: [
                                                                parseInt(e.target.value),
                                                                ...this.state.colleges
                                                            ]
                                                        });
                                                    // }
                                                    e.target.value = "";
                                                }}
                                            >
                                                <option>Select</option>
                                                {
                                                    this.state.collegeOptions.map((x, i) => <option key={i} value={x.college_master_id}>{x.name} </option>)
                                                }
                                            </Input>
                                        </Col>
                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Academic Degree: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={user.academic_degree}
                                                    name="academic_degree"
                                                    onChange={this.handleChange}
                                                >
                                                    <option>Select</option>
                                                    {
                                                        degreeOptions.map((x, i) => <option key={i} value={x.academic_degree_id}>{x.name} </option>)
                                                    }
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('academic_degree', user.academic_degree, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row className="mt-1">
                                        {
                                            this.state.colleges.length > 0
                                                ?
                                                this.state.colleges.map((x, i) => 
                                                    x !== "" &&
                                                    <Col lg={3} md={3} sm={6} xs={6}  key={i}>
                                                        <Card>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col lg={9} md={9} sm={9} xs={9}>
                                                                        {
                                                                            this.state.collegeOptions.find(y => y.college_master_id === parseInt(x)) !== undefined
                                                                                ? this.state.collegeOptions.find(y => y.college_master_id === parseInt(x)).name : ""
                                                                        }
                                                                    </Col>
                                                                    <Col lg={3} md={3} sm={3} xs={3}>
                                                                        <span className="pull-right" onClick={e => {
                                                                            this.setState({
                                                                                delete_key: "colleges",
                                                                                delete_index: i,
                                                                                alert_confirm: true
                                                                                // colleges: [...this.state.colleges].filter((y,j) =>  j !== i)
                                                                            })
                                                                        }}>
                                                                            <i className="fa fa-trash text-danger font-size-18"></i>
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                )
                                                : ""
                                            // <Col lg="4">
                                            //     <span className="text-danger">No college added yet.</span> 
                                            // </Col>

                                        }
                                    </Row>

                                    <Row>
                                        <Col lg={4}>
                                            <Label>Languages</Label>
                                            <Input
                                                type="select"
                                                // value={user.further_identity}
                                                name="further_identity"
                                                onChange={e => {

                                                    if (!this.state.languages.includes(parseInt(e.target.value))) {

                                                        this.setState({
                                                            languages: [
                                                                parseInt(e.target.value),
                                                                ...this.state.languages
                                                            ]
                                                        });
                                                    }
                                                    e.target.value = "";
                                                }}
                                            >
                                                <option>Select</option>
                                                {
                                                    this.state.languageOptions.map((x, i) => <option key={i} value={x.language_id}>{x.name} </option>)
                                                }
                                            </Input>
                                        </Col>
                                    </Row>
                                    <Row className="mt-1">
                                        {
                                            this.state.languages.length > 0
                                                ?
                                                this.state.languages.map((x, i) =>
                                                    x !== "" &&
                                                    <Col lg={3} md={3} sm={6} xs={6}  key={i}>
                                                        <Card>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col lg={9} md={9} sm={9} xs={9}>
                                                                        {
                                                                            this.state.languageOptions.find(y => y.language_id === parseInt(x)) !== undefined
                                                                                ? this.state.languageOptions.find(y => y.language_id === parseInt(x)).name : ""
                                                                        }
                                                                    </Col>
                                                                    <Col lg={3} md={3} sm={3} xs={3}>
                                                                        <span className="pull-right" onClick={e => {
                                                                            this.setState({
                                                                                delete_key: "languages",
                                                                                delete_index: i,
                                                                                alert_confirm: true
                                                                                // languages: [...this.state.languages].filter((y,j) =>  j !== i)
                                                                            })
                                                                        }}>
                                                                            <i className="fa fa-trash text-danger font-size-18"></i>
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                )
                                                : ""
                                            // <Col lg="4">
                                            //     <span className="text-danger">No Language added yet.</span> 
                                            // </Col>

                                        }
                                    </Row>

                                    <Row className="mt-3">
                                        <Col lg={12}>   <strong><h3>Social Media Handle</h3></strong></Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Instagram:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.instagram_link}
                                                    name="instagram_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Instagram', user.instagram_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Books:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.books_link}
                                                    name="books_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Book', user.books_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Ecommerce:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.Ecommerce_link}
                                                    name="Ecommerce_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('E Commerdce', user.Ecommerce_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Twitter:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.twitter_link}
                                                    name="twitter_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Twitter', user.twitter_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Blog:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.blog_link}
                                                    name="blog_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Blog', user.blog_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Website:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.website_link}
                                                    name="website_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Website', user.website_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Youtube:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.youtube_ink}
                                                    name="youtube_ink"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Youtube', user.youtube_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Social Media:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.social_media_link}
                                                    name="social_media_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Social Media', user.social_media_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Podcast:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.podcast_link}
                                                    name="podcast_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Social Media', user.podcast_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>


                                        <Col lg={4}>
                                            <FormGroup>
                                                <Label>Music:</Label>
                                                <Input
                                                    type="text"
                                                    value={user.music_link}
                                                    name="music_link"
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('Social Media', user.music_link, 'url')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <Row className="mt-3">
                                        <Col lg={12}>   <strong><h3>Documents and Gallery Images</h3></strong></Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col lg={6}>
                                            <Label>Document</Label>
                                            <Input
                                                type="file"
                                                name="document"
                                                onChange={e => {
                                                    if (e.target.files) {
                                                        // this.checkFile(e.target.files[0]);
                                                        // console.log(e.target.files[0]);
                                                        const file = e.target.files[0];
                                                        // console.log(file);
                                                        if(["docx", "pdf", "vnd.ms-excel"].includes(file.type.split("/")[1]) 
                                                            || file.name.includes("docx") || file.name.includes("pdf") || 
                                                            file.name.includes("xls") || file.name.includes("pptx")
                                                        ) {
                                                            this.setState({
                                                                document: e.target.files[0],
                                                                documentType: file.type.split("/")[1]
                                                            });
                                                        } else {
                                                            notifyError("Only .pdf, .doc, .xls, .pptx files allowed")
                                                        }
                                                        e.target.value = "";
                                                    }
                                                    // e.target.value = "";
                                                }}
                                            />
                                            <div className="dropzone-previews mt-3" id="file-previews">
                                                {
                                                    this.state.user.document && this.state.user.document !== "null" &&

                                                    <Card
                                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                        key={"file"}
                                                    >

                                                        <div className="p-2">
                                                            <Row className="align-items-center">
                                                                <Col lg={10} md={10} sm={10} xs={10}>
                                                                    <a
                                                                        href={this.state.user.document}
                                                                        className="text-info font-weight-bold"
                                                                        // target="_blank"
                                                                        download
                                                                    >
                                                                        {/* <DocViewer 
                                                                            pluginRenderer={PDFRenderer}
                                                                            documents={[{uri: this.state.user.document}]} 
                                                                        /> */}
                                                                        {/* {console.log(this.state.user.user_id)}
                                                                        {console.log(this.state.user.document.split(`user${this.state.user.user_id}/`))} */}
                                                                        {this.state.user.document.split(`user${this.state.user.user_id}/`)[1]}
                                                                    </a>
                                                                </Col>
                                                                <Col lg={2} md={2} sm={2} xs={2}>
                                                                    <p className="mb-0">
                                                                        {/* <strong>{formatBytes(this.state.document.size)}</strong> */}
                                                                        <span className="pull-right" onClick={() => {
                                                                            
                                                                            this.setState({
                                                                                delete_key: "document",
                                                                                alert_confirm: true
                                                                                // languages: [...this.state.languages].filter((y,j) =>  j !== i)
                                                                            })

                                                                            // this.setState({
                                                                            //     user: {
                                                                            //         ...user,
                                                                            //         document: null
                                                                            //     }
                                                                            // })
                                                                        }}>
                                                                            <i className="ml-2 text-danger pull-right fas fa-times"></i>
                                                                        </span>
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Card>
                                                }
                                            </div>
                                            <div className="dropzone-previews mt-3" id="file-previews">
                                                {
                                                    this.state.document !== "" &&

                                                    <Card
                                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                        key={"file"}
                                                    >

                                                        <div className="p-2">
                                                            <Row className="align-items-center">
                                                                {/* <Col className="col-auto">
                                                        <img
                                                            data-dz-thumbnail=""
                                                            height="80"
                                                            className="avatar-sm rounded bg-light"
                                                            alt={this.state.document.name}
                                                            src={URL.createObjectURL(this.state.document)}
                                                        />
                                                    </Col> */}
                                                                <Col>
                                                                    <Link
                                                                        to=""
                                                                        className="text-muted font-weight-bold"
                                                                    >
                                                                        {this.state.document.name}
                                                                    </Link>
                                                                    <p className="mb-0">
                                                                        <strong>{formatBytes(this.state.document.size)}</strong>
                                                                        <span className="pull-right" onClick={() => {
                                                                            this.setState({
                                                                                document: null
                                                                            })
                                                                        }}>
                                                                            <i className="ml-2 text-danger pull-right fas fa-times"></i>
                                                                        </span>
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Card>
                                                }
                                            </div>

                                        </Col>

                                        <Col lg={6}>
                                            <Label>Images</Label>
                                            <Input
                                                type="file"
                                                multiple
                                                name="images"
                                                onChange={e => {
                                                    if (e.target.files) {
                                                        let files = [];
                                                        for (const file of e.target.files) {
                                                            console.log(file);
                                                            if(this.checkFile(e.target.files[0])) {
                                                                files.push(file);
                                                            } else {
                                                                notifyError("Only .jpg, .png, .jpeg files allowed")
                                                            }
                                                        }
                                                        this.setState({
                                                            galleryImages: [...this.state.galleryImages].concat(files)
                                                        });
                                                    }
                                                    e.target.value = "";
                                                }}
                                            />
                                            {/* <div className="dropzone-previews mt-3" id="file-previews"> */}
                                            <section style={style.imageWrap} className="mt-2">
                                                {
                                                    this.state.galleryImagesSrc && this.state.galleryImagesSrc.length > 0
                                                        ?
                                                        this.state.galleryImagesSrc.map((x, i) =>
                                                            this.renderFile(x, i, false)   
                                                        )
                                                        : ""
                                                }
                                                {
                                                    this.state.galleryImages.length > 0
                                                        ?
                                                        this.state.galleryImages.map((x, i) =>
                                                            this.renderFile(x, i, true)   
                                                        )
                                                        : ""
                                                }
                                            </section>
                                            {/* // </div> */}
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col lg={12}>   <strong><h3>Interest and Search Criteria</h3></strong></Col>
                                    </Row>
                                    <hr />
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Label>Expertise</Label>
                                        </Col>
                                        <Col lg={6}>
                                            <Button color="info" onClick={e => {
                                                  this.updateExpertise({
                                                    key: 'expertise',
                                                    value: [...this.state.expertise.expertise, {}]
                                                });
                                            }}>
                                                <i className="fas fa-plus"></i> Add
                                            </Button>
                                        </Col>
                                        {
                                            expertise.expertise &&  expertise.expertise.length > 0
                                            ? 
                                                expertise.expertise.map((x,i) => 
                                                <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col lg={12} md={12} sm={12} xs={12}>
                                                                <div style={{"position" :"relative", "padding": "10px 5px"}}>
                                                                    <p> 
                                                                        <strong>Expertise: </strong> 
                                                                        <Input
                                                                            type={"select"}
                                                                            value={x.expert_id}
                                                                            onChange={e => {
                                                                                if(e.target.value != "") {

                                                                                    this.updateExpertise({
                                                                                        key: 'expertise',
                                                                                        value: [...this.state.expertise.expertise].map((x,key) =>  ( key == i ? {expert_id: e.target.value,subexpertise_id:"select" } : x))
                                                                                    });
                                                                                    
                                                                                    // this.loadSubExpertyise(e.target.value);
                                                                                }
                                                                                
                                                                                
                                                                            }}
                                                                        >
                                                                            <option value="" >Select</option>
                                                                            {this.state.expertiseOptions.length > 0 && this.state.expertiseOptions.map((x,i) => <option value={x.expertise_id}>{x.expertise_name}</option>)}
                                                                        </Input>
                                                                        <span className="text-danger">
                                                                            {this.validator.message('expertise', x.expert_id, 'expertise')}
                                                                        </span>
                                                                        {/* {x.expertise_name}  */}
                                                                    </p>
                                                                    <p>  <strong> Sub Expertise:</strong> 
                                                                            <Input
                                                                                type={"select"}
                                                                                value={x.sub_expertise_id}
                                                                                onChange={e => {
                                                                                    this.updateExpertise({
                                                                                        key: 'expertise',
                                                                                        value: [...this.state.expertise.expertise].map((x,key) => ( key == i ? { ...x, sub_expertise_id: e.target.value } : x))
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <option value="">Select</option>
                                                                                {this.state.subExpertiseOptions && this.state.subExpertiseOptions.filter(y => y.expertise_master_id == parseInt(x.expert_id)).map((x, i) => <option value={x.sub_expertise_id}>{x.sub_expertise_name}</option>)}
                                                                            </Input>
                                                                            <span className="text-danger">
                                                                                {this.validator.message('sub expertise', x.expert_id, 'subexpertise')}
                                                                            </span>
                                                                    {/* {x.sub_expertise_name}  */}
                                                                    </p>
                                                                    <span className="pull-right" onClick={e => {
                                                                            this.setState({
                                                                                delete_key: "expertise",
                                                                                delete_index: i,
                                                                                alert_confirm: true,
                                                                                delete_expetise: true
                                                                            });
                                                                            // this.updateExpertise({
                                                                            //     key: 'expertise',
                                                                            //     value: [...this.state.expertise.expertise].filter((y,j) => i !== j)
                                                                            // });
                                                                            // this.setState({
                                                                            //     expertise: {
                                                                            //         ...this.state.expertise,
                                                                            //         expertise: [...this.state.expertise.expertise].filter((y,j) => i !== j)
                                                                            //     }
                                                                            // })
                                                                        }}
                                                                        style={{"position": "absolute", "top" :"0px", "right" :"0px"}}>
                                                                            <i className="fa fa-trash text-danger font-size-18"></i>
                                                                        </span>
                                                                </div>
                                                                </Col>
                                                                    {/* <Col lg={3} md={3} sm={3} xs={3}>
                                                                        <span className="pull-right" onClick={e => {
                                                                            this.updateExpertise({
                                                                                key: 'expertise',
                                                                                value: [...this.state.expertise.expertise].filter((y,j) => i !== j)
                                                                            });
                                                                            // this.setState({
                                                                            //     expertise: {
                                                                            //         ...this.state.expertise,
                                                                            //         expertise: [...this.state.expertise.expertise].filter((y,j) => i !== j)
                                                                            //     }
                                                                            // })
                                                                        }}>
                                                                            <i className="fa fa-trash text-danger font-size-18"></i>
                                                                        </span>
                                                                    </Col> */}
                                                                
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                )   
                                            : 
                                                <Col lg={12}>                         
                                                    <span className="text-danger"> Not added yet </span>
                                                </Col>
                                        }
                                        
                                    </Row>
                                    <Row>
                                        <Col lg={4}> 
                                           
                                            <p> 
                                            <FormGroup>
                                                <Label>Other Expertise: </Label>
                                                <Input
                                                    type="text"
                                                    name="other_expertise"
                                                    value={expertise.other_expertise}
                                                    onChange={e => {
                                                        this.updateExpertise({
                                                            key: 'other_expertise',
                                                            value: e.target.value
                                                        });
                                                    }}
                                                    />
                                            </FormGroup>
                                                {/* <strong><h4>Other Expertise:</h4> </strong> {expertise.other_expertise}  */}
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                        <Label>Topics</Label>
                                        </Col>
                                        <Col lg={6}>
                                            <Button color="info" onClick={e => {
                                                  this.updateExpertise({
                                                    key: 'topic',
                                                    value: [...this.state.expertise.topic, {}]
                                                });
                                            }}>
                                                <i className="fas fa-plus"></i> Add
                                            </Button>
                                        </Col>
                                        {
                                            expertise.topic && expertise.topic.length > 0
                                            ?
                                                expertise.topic.map((x,i) => 
                                                    <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                                        <Card>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                                        <div style={{"position" :"relative", "padding": "10px 5px"}}>
                                                                        <p> 
                                                                        <strong>Topic: </strong> 
                                                                        <Input
                                                                            type={"select"}
                                                                            value={x.topic_id}
                                                                            onChange={e => {
                                                                                if(e.target.value) {
                                                                                    this.updateExpertise({
                                                                                        key: 'topic',
                                                                                        value: [...this.state.expertise.topic].map((x,key) => (  key == i ? {topic_id: e.target.value,subtopic_id:"select" } : x))
                                                                                    });
                                                                                    // this.loadSubTopic(e.target.value);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <option value="select">Select</option>
                                                                            {this.state.topicOptions.map((x,i) => <option value={x.topic_id}>{x.topic_name}</option>)}
                                                                        </Input>
                                                                        <span className="text-danger">
                                                                            {this.validator.message('topic', x.topic_id, 'topic')}
                                                                        </span>
                                                                        {/* {x.topic_name}  */}
                                                                    </p>
                                                                    <p>  
                                                                        <strong> Sub Topic:</strong> 
                                                                        <Input
                                                                            type={"select"}
                                                                            value={x.sub_topic_id}
                                                                            onChange={e => {
                                                                                this.updateExpertise({
                                                                                    key: 'topic',
                                                                                    value: [...this.state.expertise.topic].map((x,key) => ( key == i ? {...x, sub_topic_id: e.target.value} : x))
                                                                                });
                                                                            }}
                                                                        >   
                                                                            <option value="">Select</option>
                                                                            {this.state.subTopicOptions  && this.state.subTopicOptions.filter(y => y.topic_master_id ==x.topic_id).map((x,i) => <option value={x.sub_topic_id}>{x.sub_topic_name}</option>)}
                                                                        </Input>
                                                                        <span className="text-danger">
                                                                            {this.validator.message('sub topic', x.sub_topic_id, 'subtopic')}
                                                                        </span>
                                                                        {/* {x.sub_topic_name}  */}
                                                                    </p>
                                                                        <span 
                                                                            className="pull-right" 
                                                                            onClick={e => {
                                                                                // console.log(e.target.value);
                                                                                this.setState({
                                                                                    delete_key: "topic",
                                                                                    delete_index: i,
                                                                                    alert_confirm: true,
                                                                                    delete_expetise: true
                                                                                });
                                                                                
                                                                                // this.updateExpertise({
                                                                                //     key: 'topic',
                                                                                //     value: [...this.state.expertise.topic].filter((y,j) => i !== j)
                                                                                // });
                                                                            }} 
                                                                            style={{"position": "absolute", "top" :"0px", "right" :"0px"}}
                                                                        >
                                                                                <i className="fa fa-trash text-danger font-size-18"></i>
                                                                            </span>
                                                                            
                                                                        </div>
                                                                    
                                                                    </Col>
                                                                        {/* <Col lg={3} md={3} sm={3} xs={3}> */}
                                                                            {/* <span className="pull-right" onClick={e => {
                                                                                // console.log(e.target.value);
                                                                                this.updateExpertise({
                                                                                    key: 'topic',
                                                                                    value: [...this.state.expertise.topic].filter((y,j) => i !== j)
                                                                                });
                                                                            }}>
                                                                                <i className="fa fa-trash text-danger font-size-18"></i>
                                                                            </span> */}
                                                                        {/* </Col> */}
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                                      
                                            )    : 
                                            <Col lg={12}>                         
                                                <span className="text-danger"> Not added yet </span>
                                            </Col>   
                                        }
                                        {/* <Col lg={12}> 
                                            <p> <strong><h4>Other Topic: </h4> </strong> {expertise.other_topic} </p>
                                        </Col> */}
                                    </Row>
                                    <Row>
                                        <Col lg={4}> 
                                           
                                            <p> 
                                            <FormGroup>
                                                <Label>Other Topic:</Label>
                                                <Input
                                                    type="text"
                                                    name="other_topic"
                                                    value={expertise.other_topic}
                                                    onChange={e => {
                                                        this.updateExpertise({
                                                            key: 'other_topic',
                                                            value: e.target.value
                                                        });
                                                    }}
                                                    />
                                            </FormGroup>
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                           <Label>Interests</Label>
                                        </Col>
                                        <Col lg={6}>
                                            <Button color="info" onClick={e => {
                                                  this.updateExpertise({
                                                    key: 'interest',
                                                    value: [...this.state.expertise.interest, {}]
                                                });
                                            }}>
                                                <i className="fas fa-plus"></i> Add
                                            </Button>
                                        </Col>
                                        {
                                            expertise.interest && expertise.interest.length > 0 
                                             ?
                                             expertise.interest.map((x,i) => 
                                                <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col lg={9} md={9} sm={9} xs={9}>

                                                                    <Select
                                                                        value={interets && interets.find(y => y.value === x.interested_on_id)}
                                                                        options={interets && interets }
                                                                        onChange={e => {
                                                                            console.log(e);
                                                                            x.interested_on_id = e.value;
                                                                            console.log(x);
                                                                            this.updateExpertise({
                                                                                key: 'interest',
                                                                                value: [...expertise.interest].map((y,key) => ( key == i ? { ...y, interested_on_id: e.value} : y))
                                                                            });
                                                                        }}
                                                                    />
                                                                     <span className="text-danger">
                                                                            {this.validator.message('interest', x.interested_on_id, 'required')}
                                                                        </span>
                                                                    {/* <Input
                                                                        type="select"
                                                                        value={x.interested_on_id ? x.interested_on_id : ""}
                                                                        onChange={e => {
                                                                            console.log(e.target.value);
                                                                            console.log(e.target.label);
                                                                            
                                                                            // console.log([...this.state.expertise.interest].map((x,key) => ( key == i ? { ...x, interested_on_id: e.target.value} : x)));
                                                                            this.updateExpertise({
                                                                                key: 'interest',
                                                                                // value: temp
                                                                                value: [...expertise.interest].map((y,key) => ( key == i ? {interested_on_id: e.target.value,  ...y} : y))
                                                                            });
                                                                        }}
                                                                    >
                                                                        <option value="select">Select</option>
                                                                        {this.state.interestsOptions && this.state.interestsOptions.filter(x => [...this.state.expertise.interest].find(y =>  y.interested_on_id != x.interested_on_id ) ? true : false ).map((z,i) => <option value={z.interested_on_id}>{z.name}</option>)}
                                                                    </Input>
                                                                     */}
                                                                    {/* <p> <strong>Topic: </strong> {x.name} </p> */}
                                                                </Col>
                                                                    <Col lg={3} md={3} sm={3} xs={3}>
                                                                        <span className="pull-right" onClick={e => {
                                                                             this.setState({
                                                                                delete_key: "interest",
                                                                                delete_index: i,
                                                                                alert_confirm: true,
                                                                                delete_expetise: true
                                                                            });
                                                                            // this.updateExpertise({
                                                                            //     key: 'interest',
                                                                            //     value: [...this.state.expertise.interest].filter((y,j) => j != i)
                                                                            // });
                                                                        }}
                                                                        style={{"position": "absolute", "top" :"0px", "right" :"0px"}}>
                                                                            <i className="fa fa-trash text-danger font-size-18"></i>
                                                                        </span>
                                                                    </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                )
                                            :   
                                            <Col lg={12}>                         
                                                <span className="text-danger"> Not added yet </span>
                                            </Col>   
                                        }
                                    </Row>

                                    <Row>
                                        <Col lg={4}  md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>Converse With: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={expertise.converse_with}
                                                    name="converse_with"
                                                    onChange={e => {
                                                        this.updateExpertise({
                                                            key: 'converse_with',
                                                            value: e.target.value
                                                        });
                                                    }}
                                                >
                                                    <option>Select</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('Converse with', expertise.converse_with, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col lg={4}  md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>Age Range: {this.renderStar()}</Label>
                                                <InputRange
                                                    // classNames="mt-1"
                                                    maxValue={65}
                                                    minValue={18}
                                                    // formatLabel={value => `${value} kg`}
                                                    value={ this.state.ageRange }
                                                    onChange={value => this.setState({ ageRange: value })}
                                                    onChangeComplete={value => console.log(value)} />
                                                {/* <span className="text-danger">
                                                    {this.validator.message('DOB', user.DOB, 'required')}
                                                </span> */}
                                            </FormGroup>
                                        </Col>
                                        <Col lg={4}  md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>Body Type: {this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={expertise.body_type}
                                                    name="body"
                                                    onChange={e => {
                                                        this.updateExpertise({
                                                            key: 'body_type',
                                                            value: e.target.value
                                                        });
                                                    }}
                                                >
                                                    <option>Select</option>
                                                    {
                                                        bodyTypeOptions.map((x, i) => <option key={i} value={x.body_type_id}>{x.name} </option>)
                                                    }
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('Body type', expertise.body_type, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={4}  md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>No Distance Limit within country:{this.renderStar()}</Label>
                                                <Input
                                                    type="select"
                                                    value={expertise.distance_limited_by_country}
                                                    name="converse_with"
                                                    onChange={e => {
                                                        this.updateExpertise({
                                                            key: 'distance_limited_by_country',
                                                            value: e.target.value
                                                        });
                                                    }}
                                                >
                                                    <option>Select</option>
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </Input>
                                                <span className="text-danger">
                                                    {this.validator.message('distance_limited_by_country', expertise.distance_limited_by_country, 'required')}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col lg={4}  md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>Maxiumu Distance (miles):{this.renderStar()}</Label>
                                                <InputRange
                                                    maxValue={100}
                                                    minValue={1}
                                                    value={expertise.maximum_distance || 0}
                                                    onChange={value => {
                                                        this.updateExpertise({
                                                            key: "maximum_distance",
                                                            value: value
                                                        })
                                                    }}
                                                    onChangeComplete={value => console.log(value)} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mt-1">
                                        <Col lg={12}>
                                            <Label>Wish List</Label>
                                        </Col>
                                            
                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>First Name:  </Label>
                                                <Input
                                                    type="text"
                                                    value={this.state.wishlist_name}
                                                    name="wishlist_name"
                                                    onChange={e => {
                                                        this.setState({
                                                            wishlist_name: e.target.value
                                                        });
                                                    }}
                                                    bsSize="lg"
                                                    placeholder="First Name"
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('First name', this.state.wishlist_name, 'required|alpha_space|min:5|max:20')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        <Col lg={3} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label>Last Name: </Label>
                                                <Input
                                                    type="text"
                                                    value={this.state.wishlist_last_name}
                                                    name="wishlist_last_name"
                                                    onChange={e => {
                                                        this.setState({
                                                            wishlist_last_name: e.target.value
                                                        });
                                                    }}
                                                    bsSize="lg"
                                                    placeholder="Last Name"
                                                />
                                                <span className="text-danger">
                                                    {this.validator.message('First name', this.state.wishlist_last_name, 'required|alpha_space|min:5|max:20')}
                                                </span>
                                            </FormGroup>
                                        </Col>

                                        {/* {this.state.instagram_visible && */}
                                            <Col lg={3} md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>Instagram: </Label>
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText><i className="fab fa-instagram"></i></InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input 
                                                        placeholder="Instagram Handle" 
                                                        value={ this.state.instagram_link}
                                                        onChange={e => {            
                                                            this.setState({
                                                                instagram_link: e.target.value
                                                            });
                                                        }} 
                                                    />
                                                </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        {/* }  */}
                                        {/* {this.state.twitter_visible && */}
                                            <Col lg={3} md={6} sm={6} xs={6}>
                                            <FormGroup>
                                                <Label>Twitter: </Label>
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText><i className="fab fa-twitter"></i></InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input 
                                                        placeholder="Twitter Handle" 
                                                        value={ this.state.twitter_link || ""} 
                                                        onChange={e => {    
                                                            this.setState({
                                                                twitter_link: e.target.value
                                                            });
                                                        }} 
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                            </Col>
                                        {/* }  */}
                                    </Row>
                                    <Row className="mt-3">
                                        <Col lg={9}></Col>
                                        <Col lg={3}>
                                            <Button color="success" onClick={this.handleSubmit}>Save</Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            {this.state.alert_confirm ? (
								<SweetAlert
									title="Are you sure?"
									warning
									showCancel
									confirmBtnBsStyle="success"
									cancelBtnBsStyle="danger"
									onConfirm={() => {
                                        this.deleteItem();

										// this.delete()
                                    }}
									onCancel={() =>
										this.setState({
											alert_confirm: false,
                                            delete_index: -1,
                                            delete_key: ""
										})
									}
								>
									You won't be able to revert this!
								</SweetAlert>
							) : null}
                        </div>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
};

export default AddUser;